import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintWatchShiftViewProps } from "./Params"

export function PrintWatchShiftView({ shift, index: _index }: PrintWatchShiftViewProps) {
  const app = GetApp();
  const t = app.getT("DayWatchView_shifts");

  return (
    <BlockRow className="print-day-watch-shifts">
      <BlockField label={t("hour")} className="block-field-90">{shift.start}</BlockField>
      <BlockField label={t("duration")} className="block-field-90">{shift.duration}</BlockField>
      <BlockField label={t("group")} className="block-field-90">{shift.group}</BlockField>
    </BlockRow>
  );
}
